import { getSlateSpacingPixels } from "@faire/retailer-shared/SlateMappings/getSlateSpacingPixels";
import { Spacing } from "@faire/web-api/indigofair/data/Spacing";
import { ResponsiveValues } from "@faire/web/slate/Theme/ResponsiveValues";

import * as gridStyles from "@faire/retailer/components/SDUI/ComponentRenderers/Grid/__internal__/styles.css";

export const AUTO_COLUMN_LAYOUT_GRID_MAX_TILES_PER_ROW = 9;

export const getGridRowGapStyleVariable = (
  rowSpacing: keyof typeof Spacing = Spacing.SPACING_NONE
) => {
  return { [gridStyles.varRowGap]: `${getSlateSpacingPixels(rowSpacing)}px` };
};

export const autoGridStyles = (
  rowSpacing: keyof typeof Spacing = Spacing.SPACING_NONE,
  columnSpacing: keyof typeof Spacing = Spacing.SPACING_NONE,
  responsiveTileWidth: ResponsiveValues<number>
) => {
  return {
    [gridStyles.varColumnTemplateMobile]: responsiveTileWidth.mobileAndAbove
      ? `repeat(auto-fill, ${responsiveTileWidth.mobileAndAbove}px)`
      : `repeat(auto-fit, min-content)`,
    [gridStyles.varColumnTemplateTablet]: responsiveTileWidth.tabletAndAbove
      ? `repeat(auto-fill, ${responsiveTileWidth.tabletAndAbove}px)`
      : `repeat(auto-fit, min-content)`,
    [gridStyles.varColumnTemplateDesktop]: responsiveTileWidth.desktopAndAbove
      ? `repeat(auto-fill, ${responsiveTileWidth.desktopAndAbove}px)`
      : `repeat(auto-fit, min-content)`,

    [gridStyles.varColumnGap]: `${getSlateSpacingPixels(columnSpacing)}px`,
    ...getGridRowGapStyleVariable(rowSpacing),
  };
};

export const getFixedColumnGridStyleVariables = (
  responsiveNumberOfColumns: ResponsiveValues<number>,
  columnSpacing: keyof typeof Spacing = Spacing.SPACING_NONE,
  rowSpacing: keyof typeof Spacing = Spacing.SPACING_NONE
) => {
  return {
    [gridStyles.varColumnTemplateMobile]: `repeat(${responsiveNumberOfColumns.mobileAndAbove}, 1fr)`,
    [gridStyles.varColumnTemplateTablet]: `repeat(${responsiveNumberOfColumns.tabletAndAbove}, 1fr)`,
    [gridStyles.varColumnTemplateDesktop]: `repeat(${responsiveNumberOfColumns.desktopAndAbove}, 1fr)`,
    [gridStyles.varColumnTemplateXLarge]: `repeat(${responsiveNumberOfColumns.xLargeAndAbove}, 1fr)`,
    [gridStyles.varColumnGap]: `${getSlateSpacingPixels(columnSpacing)}px`,
    ...getGridRowGapStyleVariable(rowSpacing),
  };
};
